<template>
  <div class="page">
    <Header />
    <div class="main">
      <slot />
    </div>
    <Footer />
    <LazyCategoryModal
      :show="showCategoryModal"
      @close="showCategoryModal = false"
      v-if="showCategoryModal"
    />
    <div
      v-if="darkBg"
      class="fixed top-0 right-0 bottom-0 left-0 z-[100] bg-[#000] bg-opacity-50"
    ></div>
  </div>
</template>

<script lang="ts" setup>
import { provide, onBeforeMount } from "vue";
import { useI18n } from "vue-i18n";
import { PROVIDE_CATEGORY_MODAL_KEY, PROVIDE_DARK_BG } from "~/utils/defs";
import { useStateStore } from "~/store/state";

const showCategoryModal = ref<boolean>(false);
provide(PROVIDE_CATEGORY_MODAL_KEY, showCategoryModal);

const stateStore = useStateStore();
const { getItem } = useLocalStorage();
const { locale } = useI18n();
const darkBg = ref<boolean>(false);
provide(PROVIDE_DARK_BG, darkBg);

await stateStore.prepareCurrentState();

onBeforeMount(() => {
  const l = getItem(LOCALE_KEY, locale.value);
  if (l != locale.value) locale.value = l.value;
});
</script>

<style>
input,
textarea,
select {
  font-size: 16px !important;
}
</style>
